import { render, staticRenderFns } from "./TopTenAccountsByExpectedRevenue.vue?vue&type=template&id=378f840e&"
import script from "./TopTenAccountsByExpectedRevenue.vue?vue&type=script&lang=js&"
export * from "./TopTenAccountsByExpectedRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports